<template>
  <div>
    <vue-headful title="Profiel Weergave" />
    <Header page_title="Profiel Weergave" />
    <div v-if="userCandidate" id="profile" class="profile-layout app-body">
      <div class="profile-notifications">
        <div class="container-fluid">
          <div v-if="userCandidate.is_interested == 1" class="sd-notif success mb-2"><svg-icon icon="thumbs_up" />Je hebt interesse getoond in deze persoon!</div>
          <div v-if="userCandidate.is_interview_invited == 1" class="sd-notif success mb-2"><svg-icon icon="thumbs_up" />Je hebt deze persoon uitgenodigd voor een kennismaking!</div>
          <div v-if="userCandidate.is_declined == 1" class="sd-notif danger mb-2"><svg-icon icon="trash" />Je hebt deze persoon afgewezen</div>
        </div>
      </div>
      <div class="profile-intro">
        <div class="container-fluid">
          <h1 class="sd-title bold small pb-4">Hi, ik ben {{ userCandidate.firstname }}</h1>
          <div class="profile-specs">
            <div class="avatar rounded-circle position-relative overflow-hidden">
              <span v-if="userCandidate.avatar" class="d-block image_background" :style="this.ImageBackground(userCandidate.avatar)"></span>
              <svg-icon v-else icon="person_male" />
            </div>
            <div class="profile-specs-info">
              <div class="location"><svg-icon icon="marker"></svg-icon>{{ userCandidate.name_location }} ({{ userCandidate.city_location }})</div>
            </div>
          </div>
        </div>
      </div>
      <svg-icon icon="wave" class="seperator" />
      <div class="profile-messages bg-gray" v-if="userCandidate.interested_comment || userCandidate.comment || userCandidate.hired_comment">
        <div class="container-fluid no-grid">
          <div class="sd-title mini mb-20px">
            <div class="title-text"><svg-icon icon="blackboard" /> Berichten</div>
          </div>
        </div>
        <div class="container-fluid pt-1 px-0">
          <div class="message interested" v-if="userCandidate.interested_comment">
            <div class="sd-title mini">{{ userCompany.name }}</div>
            <div class="sd-notif warning interested">
              <div class="small text-left br">{{ userCandidate.interested_comment }}</div>
            </div>
          </div>
          <div class="message apply" v-if="userCandidate.comment">
            <div class="sd-title mini text-align-right">{{ userCandidate.firstname }}</div>
            <div class="sd-notif warning apply" >
              <div class="small text-left br">{{ userCandidate.comment }}</div>
            </div>
          </div>
          <div class="alert alert-warning hired" v-if="userCandidate.hired_comment">
            <div class="small text-left br">{{ userCandidate.hired_comment }}</div>
          </div>
        </div>
      </div>
      <div class="job-notification-banner bg-gray" v-if="userCompany.type == 2">
        <div class="container-fluid">
            <NotificationBanner notification="warning">
              <b>Even overleggen over deze kandidaat?</b>
              <ul>
                <li>Bel ons op: <a href="tel:+31850481976">085 048 1976</a></li>
                <li>Contact ons via <a class="" :href="`https://api.whatsapp.com/send?phone=31850481976&text=${encodeURIComponent(this.whatsappMessage)}`">Whatsapp</a></li>
                <li>Stuur ons een <router-link
                    :to="{ name: 'contact' }"
                >berichtje</router-link
                ></li>
              </ul>
            </NotificationBanner>
        </div>
      </div>

      <div class="profile-calendar bg-gray">
        <div id="calendar" class="pb-4">
          <div class="container-fluid">
            <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="blackboard" />Vacature</h2>
            <div class="sd-container small-radius bg-white text">
              <div class="availablity-specs">
                <template v-if="job.city">
                  <strong>Locatie</strong>
                  <span>{{ job.company_name }} ({{ job.city }})</span>
                </template>
                <strong v-if="this.job.group">Doelgroep(en) en kwalificatie(s)</strong> <span v-if="this.job.group">{{ groupsArrayToString }} - {{ qualificationsArrayToString }}</span>
                <strong>Start-/einddatum</strong> <span>{{ new Date(this.job.start_date).toLocaleDateString() }}{{ ("/" + new Date(this.job.end_date).toLocaleDateString()) }}</span>
                <strong v-if="this.job.periods">Aantal lesuur per week</strong> <span v-if="this.job.periods">{{ this.job.periods }} uur</span>
                <strong v-if="this.job.healthcare_availability">Diensten</strong><span v-if="this.job.healthcare_availability">{{ healthcareAvailabilityText }}</span>
                <strong>Moet over eigen vervoer hebben</strong><span>{{ hasTransport ? 'Ja' : 'Nee' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="profile-experience">
          <div class="container-fluid">
            <div class="position-relative">
              <h2  class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="suitcase" />Profielschets</h2>
              <div class="sd-container small-radius bg-white text position-relative">
                <div class="details position-relative">
                  <p class="mb-2">
                    <span class="d-inline-block position-relative" v-if="this.userCandidate.derect_about_candidate" v-html="this.userCandidate.derect_about_candidate"></span>
                    <span v-else>
                      Derect heeft een (digitale) kennismaking met iedere kandidaat. Hier vind je onze profielschets zodra die gereed is.
                    </span>
                  </p>
                </div>
              </div>
              <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="diploma" />Ervaring</h2>
            </div>
              <div class="sd-container small-radius bg-white text position-relative">
              <div class="details position-relative">
                <div class="position-relative">
                    <div class="branch-school subbranch-secondary">
                        <div class="availablity-specs">
                            <strong>Doelgroep(en)</strong> <span>{{ formattedGroup() }}</span>
                            <strong>Kwalificatie(s)</strong> <span>{{ formattedQualifications() }}</span>
                            <strong>Specialisatie(s)</strong> <span>{{ formattedSpecialization() }}</span>
                            <strong>Beschikt over eigen vervoer?</strong> <span>{{ userHasOwnTransport() }}</span>
                            <strong>Adres</strong> <span>{{ userCandidate.name_location }} ({{ userCandidate.city_location }})</span>
                        </div>
                    </div>
                </div>
          </div>
                </div>
                </div>
              </div>

        <div class="profile-buttons bg-gray pb-4">
          <div class="container-fluid">
            <button
              v-if="interestedNotif && userCandidate.is_interested !== 1"
              type="button"
              v-on:click.stop="onInterestedNotification()"
              class="btn btn-warning btn-block"
            >Interesse tonen</button>
            <button
                v-if="!hired && hiredNotif && !userCandidate.is_declined && userCandidate.is_interview_invited != 1"
                v-on:click.stop="onInvitation()"
                type="button"
                class="btn btn-warning btn-block"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Plan een kennismaking</button>
            <button
                v-if="!hired && hiredNotif && !userCandidate.is_declined"
                v-on:click.stop="onDecline()"
                type="button"
                class="btn btn-danger btn-block"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Sollicitatie afwijzen</button>
            <button
              v-if="hired && !show_info"
              v-on:click="show_info = true"
              type="button"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Contact Info</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fullscreen_notif == 'comment'" class="fullscreen-notif match position-fixed">
      <button
        type="button"
        class="close position-fixed"
        aria-label="Close"
        v-on:click="fullscreen_notif = null; job_applicant_id = null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <div class="form-group text-left">
                <h4>Heb je nog vragen of opmerkingen voor {{ userCandidate.firstname }}?</h4>
              </div>
              <div class="form-group mb-4">
                <textarea
                  maxlength="160"
                  class="form-control"
                  :placeholder="'Laat hier een bericht achter voor de kandidaat. Bijvoorbeeld: overleg van de dagen, vaardigheden, de periode, enz. \n(max 160 karakters)'"
                  rows="4"
                  spellcheck="false"
                  v-model="comment"
                ></textarea>
                <span class="extra-info text-left mt-2">
                  <svg-icon icon="information" />
                  Laat hier een bericht achter voor de kandidaat. Bijvoorbeeld: overleg van de dagen, vaardigheden, de periode, enz. (max 160 karakters)
                </span>
              </div>
              <a v-if="interestedNotif && !hiredNotif" class="btn btn-warning btn-block" role="button" @click="onInterested">Doorgaan</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fullscreen_notif == 'decline'" class="fullscreen-notif match position-fixed">
      <button
          type="button"
          class="close position-fixed"
          aria-label="Close"
          v-on:click="fullscreen_notif = null; job_applicant_id = null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <div class="text-left">
                <h4>Weet je zeker dat je de sollicitatie van {{ userCandidate.firstname }} wilt afwijzen?</h4>
                <h5>De sollicitant ontvangt hier een automatisch bericht van.</h5>
              </div>
              <a class="btn btn-warning btn-block" role="button" @click="onSubmitDecline">Doorgaan</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fullscreen_notif == 'invitation'" class="fullscreen-notif match position-fixed">
      <button
          type="button"
          class="close position-fixed"
          aria-label="Close"
          v-on:click="fullscreen_notif = null; job_applicant_id = null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />

              <div class="form-group text-left">
                <h5>Heb je specifieke vragen voor/over deze kandidaat of opmerkingen m.b.t. de vacature?</h5>
              </div>
              <div></div>
              <div class="form-group mb-4">
                <textarea
                    maxlength="160"
                    class="form-control"
                    :placeholder="'Laat hier een bericht achter voor Derect. \n(max 160 karakters)'"
                    rows="4"
                    spellcheck="false"
                    v-model="comment"
                ></textarea>
              </div>
              <div class="form-group mb-4">
                <div class="form-group text-left">
                  <h5>Op welke dagen/momenten kan het kennismakingsgesprek plaatsvinden?</h5>
                </div>
                <textarea
                    maxlength="160"
                    class="form-control"
                    :placeholder="'Laat hier een bericht achter voor Derect. \n(max 160 karakters)'"
                    rows="4"
                    spellcheck="false"
                    v-model="schedule"
                ></textarea>
              </div>
<!--              <a v-if="interestedNotif && !hiredNotif" class="btn btn-warning btn-block" role="button" @click="onInterested">Doorgaan</a>-->
              <a v-if="!interestedNotif && hiredNotif" class="btn btn-warning btn-block" role="button" @click="onSubmitInvitation">Verstuur aan Derect</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Hired
      v-model="show_info"
      v-if="hired && show_info"
      :user="hired"
      :show="true"
      :create_new="create_new"
    />
    <Footer />
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";
import JobDatesOverview from "@/components/JobDatesOverview";

export default {
  data: function() {
    return {
      diplomas: '',
      branch: localStorage.getItem("branch"),
      userCandidate: null,
      userCompany: null,
      companyContact: null,
      hired: null,
      show_info: false,
      whatsappMessage: "",
      profession: "",
      reviews: null,
      show_calendar: false,
      week: 2,
      highlight: [],
      fullscreen_notif: null,
      interestedNotif: this.$route.name === 'view-healthcare-match',
      hiredNotif: this.$route.name === 'view-healthcare-applicant',
      comment: "",
      schedule: "",
      unmatched_reasons: {},
      create_new: false,
      totalMatchedDays: null,
        job: null,
    };
  },
  props: ["id"],
  computed: {
      healthcareAvailabilityText() {
          const raw = this.job.healthcare_availability;
          if (!raw) return 'Nog niet ingevuld';

          let parsed;
          try {
              parsed = JSON.parse(raw);
          } catch {
              return 'Nog niet ingevuld';
          }

          const labelMap = {
              day: 'Dag',
              evening: 'Avond',
              night: 'Nacht',
              weekend: 'Weekend'
          };

          return Object.keys(parsed)
              .filter(key => parsed[key] === true && key !== 'hasTransport')
              .map(key => labelMap[key])
              .join(', ') || 'Nog niet ingevuld';
      },

      hasTransport() {
          const raw = this.job.healthcare_availability;
          if (!raw) return false;

          try {
              const parsed = JSON.parse(raw);
              return !!parsed.hasTransport;
          } catch {
              return false;
          }
      },

      groupsArrayToString() {
          let groups = '';
          let groups_array = this.job.group;

          if (!groups_array) return 'Nog niet ingevuld';

          for(const key in groups_array) {
              groups += groups_array[key] + ', ';
          }

          return groups.slice(0, -2);
      },

      qualificationsArrayToString() {
          let qualifications = '';

          for(const key in this.job.qualification) {
              qualifications += this.job.qualification[key] + ', ';
          }

          return qualifications.slice(0, -2);
      },
  },
  async created() {},

  async mounted() {
    await this.fetchData();
  },

  watch: {
    $route: "fetchData"
  },

  methods: {
    async fetchData() {
      this.$store.state.loading = true;

      this.userCompany = JSON.parse(localStorage.getItem("user"));

      if(this.$route.name == 'view-healthcare-match')
      {
        this.userCandidate = await this.getTokenAPIList("matched/" + parseInt(this.id));

          if(this.userCandidate.job_id) {
              this.job = await this.getTokenAPIList("job/" + this.userCandidate.job_id);
          }
      }
      else if(this.$route.name == 'view-healthcare-applicant') //Als school een sollicitant bekijkt
      {
        this.userCandidate = await this.getTokenAPIList("applicant/" + parseInt(this.id));

          if(this.userCandidate.job_id) {
              this.job = await this.getTokenAPIList("job/" + this.userCandidate.job_id);
          }
      }

      if(this.userCandidate && this.userCandidate.unmatched_reasons)
      {
        this.unmatched_reasons = JSON.parse(this.userCandidate.unmatched_reasons);
        for (var key in this.unmatched_reasons) {
          if (key === "dates")
            this.create_new = true;
        }
      }

      if(this.userCandidate)
      {
        if(this.userCandidate.time_add_on)
          this.userCandidate.time_add_on = parseFloat(this.userCandidate.time_add_on);
      }

      this.whatsappMessage = "Ik heb een vraag over de kandidaat: " +
          this.userCandidate.firstname +
          ". Bij vacature: " +
          (this.userCandidate.title || this.userCandidate.job_title) +
          " (vacaturenummer: " + this.userCandidate.job_id + ").";

      this.$forceUpdate();
      this.$store.state.loading = false;
    },

    formattedGroup() {
        let groups_array = this.userCandidate.groups;
        if (!groups_array) return 'Nog niet ingevuld';

        return groups_array.map(item => item.answer).join(', ');
    },

      formattedQualifications() {
        let qualifications_array = this.userCandidate.qualifications;
        if (!qualifications_array) return 'Nog niet ingevuld';

        return qualifications_array.map(item => item.answer).join(', ');
      },

      formattedSpecialization() {
        let specialization_array = this.userCandidate.specializations;
        if (!specialization_array) return 'Nog niet ingevuld';

        return specialization_array.map(item => item.answer).join(', ');
      },

      userHasOwnTransport() {
          const raw = this.userCandidate.healthcare_availability;
          if (!raw) return false;

          try {
              const parsed = JSON.parse(raw);
              return !!parsed.hasTransport ? 'Ja' : 'Nee';
          } catch {
              return 'Nee';
          }
      },

    async onInterestedNotification() {
      this.fullscreen_notif = "comment";
    },

    async onInterested() {
      return new Promise((resolve, reject) => {
        this.$store.state.loading = true;

        var url = this.$apiURI + "/interest";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        let formData = new FormData();
        formData.append("match_id", parseInt(this.userCandidate.match_id));
        formData.append("comment", this.comment);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            this.$store.state.loading = false;
            this.userCandidate.is_interested = 1;
            this.comment = "";
            this.fullscreen_notif = null;
            resolve();
          })
          .catch(error => {
            this.$store.state.loading = false;
            this.comment = "";
            this.fullscreen_notif = null;
            reject();
          });
      });
    },

    async onAccept() {
      this.fullscreen_notif = "comment";
    },

    async onInvitation() {
      this.fullscreen_notif = "invitation";
    },

    async onDecline() {
      this.fullscreen_notif = "decline";
    },

    async onSubmitInvitation() {
      this.$store.state.loading = true;
      this.sendInvitation(parseInt(this.id), this.comment, this.schedule)
          .then(() => {
            this.fullscreen_notif = null;
            this.$router.push('/company/applicants')
          })
          .catch(() => {
            this.fullscreen_notif = "comment";
          });
    },

    async onSubmitDecline() {
      this.$store.state.loading = true;
      this.declineApplicant(parseInt(this.id))
          .then(() => {
            this.fullscreen_notif = null;
            this.$router.push('/company/applicants')
          })
          .catch(() => {
            this.fullscreen_notif = "decline";
          });
    },

    translate(answer) {
      if (answer == "NO") {
        return "Nee";
      }
      if (answer == "YES") {
        return "Ja";
      }
      if (answer == "STUDYING") {
        return "Studerend";
      }
      return answer;
    },

    // printDiplomas(currentBranch) {
    //   var diplomas = [];
    //
    //   if(currentBranch.education["1_YES"]) {
    //     diplomas.push("Pabo (diploma, " + currentBranch.education["1_YES"] + ")");
    //   }
    //   if (currentBranch.education["1_STUDYING_A"]) {
    //     diplomas.push("Pabo " + "(" + currentBranch.education["1_STUDYING_A"] + ", " + currentBranch.education["1_STUDYING_B"] + ")");
    //   }
    //   if (currentBranch.education["2_YES"]) {
    //     diplomas.push("Onderwijsassistent (diploma, " + currentBranch.education["2_YES"] + ")");
    //   }
    //   if (currentBranch.education["2_STUDYING_A"]) {
    //     diplomas.push("Onderwijsassistent " + "(" + currentBranch.education["2_STUDYING_A"] + ", " + currentBranch.education["2_STUDYING_B"] + ")");
    //   }
    //   if (currentBranch.education["3_YES"]) {
    //     diplomas.push("Eerste- of tweedegraads docent (diploma, " + currentBranch.education["3_YES"] + ")");
    //   }
    //   if (currentBranch.education["3_STUDYING_A"]) {
    //     diplomas.push("Eerste- of tweedegraads docent " + "(" + currentBranch.education["3_STUDYING_A"] + ", " + currentBranch.education["3_STUDYING_B"] + ")");
    //   }
    //   if (currentBranch.education["4_YES"]) {
    //     diplomas.push("Master (SEN) (diploma, " + currentBranch.education["4_YES"] + ")");
    //   }
    //   if (currentBranch.education["4"] == "STUDYING") {
    //     diplomas.push("Master (SEN) (Studerend)");
    //   }
    //   if (currentBranch.education["5_YES"]) {
    //     diplomas.push("Buitenlandse bevoegheid (diploma, " + currentBranch.education["5_YES"] + ")");
    //   }
    //   if (currentBranch.education["5"] == "STUDYING") {
    //     diplomas.push("Buitenlandse bevoegheid (Studerend)");
    //   }
    // },
  },

  ready() {
    this.$forceUpdate();
  },

  components: {
    Achievements,
    JobDatesOverview
  }
};
</script>

<style scoped>
.profile-layout {
  margin-top: 40px;
}

/deep/.profile-layout .profile-intro .profile-specs .avatar .svg-container {
  padding: 15px;
}

/deep/.profile-layout .profile-intro .profile-specs .avatar .svg-container,
/deep/.profile-layout .profile-intro .profile-specs .avatar .svg-container svg {
  height: 100%;
  width: 100%;
}

.profile-layout .job-notification-banner {
  padding-top: 25px;
}

.profile-layout .profile-messages {
  padding-top: 20px;
  padding-bottom: 20px;
}

.profile-layout .profile-messages .container-fluid:not(.no-grid) {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.profile-layout .profile-messages .container-fluid .message .sd-title {
  margin-left: 15px;
}

.profile-layout .profile-messages .container-fluid .message.interested {
  grid-row: 1;
  grid-column: 1;
}

.profile-layout .profile-messages .container-fluid .message.apply {
  grid-row: 2;
  grid-column: 2;
}

.profile-layout .profile-calendar .availablity-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 15px;
  background-color: #FFF;
  font-size: 12px;
  line-height: 1;
}

.profile-layout .profile-calendar .calendar-container {
  border-radius: 10px;
  padding: 15px 30px;
  margin-bottom: 20px;
}

.profile-layout .profile-calendar .calendar-container .click-container {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile-layout .profile-calendar .calendar-container .syncfusion-calendar {
  top: 5px;
  left: 0;
  z-index: 1;
}

.profile-layout .profile-calendar .sd-container {
  padding-bottom: 15px;
}

#profile .avatar {
  border-width: 4px;
}
.text {
  font-size: 14px;
  line-height: 22px;
}

.education span {
  display: block;
}

.btn-sm {
  background-color: #FFCD00;
  font: 13px/35px "Real Head Pro";
  font-weight: normal;
  color: #625a55;
  height: 35px;
  padding: 0 15px;
  border-radius: 4px;
}
.seperator {
  display: block;
  width: 100%;
  color: #F6F6F6;
}

.fullscreen-notif .avatar {
  width: 200px;
  height: 200px;
  border: 7.2pt solid white !important;
}

.fullscreen-notif p {
  font-size: 20px;
  line-height: 120%;
  white-space: pre-wrap;
  word-break: break-word;
}

.fullscreen-notif .text-left p {
  font-size: 15px;
  line-height: 100%;
  font-variant-numeric: lining-nums;
  font-family: "Real Head Pro";
  font-weight: 200;
}

header.overflow-hidden + div:not(.min-height)#profile {
  /* padding-bottom: 210px; */
  padding-bottom: 80px;
}

.add-comma span:not(:last-child):after {
  content: ",";
  margin-right: 3px;
}
#profile .info-group > div > div:not(:first-child) .details:before {
  display: none;
}

#profile #calendar .clearfix {
  height: auto;
}

.profile-layout .tab-container {
  border-radius: 0 30px 30px 30px
}

.profile-layout .tab-item-container {
  display: flex;
}

.profile-layout .tab-item-container .tab-item {
  border: 1px solid #64513D;
  border-bottom: 0;
  padding: 5px 15px;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  cursor: pointer;
}

.profile-layout .tab-item-container .tab-item.active {
  background-color: #FFF;
  border-color: #FFF;
}

.profile-layout .tab-item-container .tab-item:not(:last-child) {
  margin-right: 10px;
}

.achievements_container {
  position: relative;
  z-index: 5;
  display: inline-block;
}
/deep/ .achievements_container .achievement {
  margin-top: 30px;
}
.title-with-icon {
  display: flex;
  align-items: center;
}
/deep/ .title-with-icon .svg-container {
  display: flex;
  align-items: center;
}
/deep/ .title-with-icon svg {
  color: #ffcd00;
  margin-right: 15px;
  width: 15px;
}
.pie-container {
  display: flex;
  align-items: center;
}

.pie-container ul {
  list-style: none;
  padding-left: 0;
}

.pie-container ul li {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 20px;
}

.pie-container ul li::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  height: 5px;
  width: 5px;
  border-radius: 100%;
  background-color: #FFCD00;
}

.alert_pie {
  position: relative;
}
.alert_pie span {
  font-size: 14px;
  position: absolute;
  color: #fff;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.alert_pie.full-marks {
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert_pie.full-marks span {
  bottom: unset;
  left: unset;
  transform: unset;
}

/deep/.pie-container svg {
  width: 60px;
}
/deep/.pie-container svg .filled-chart {
  fill: #ffcd00;
}
/deep/.pie-container svg .empty-chart {
  fill: #fff;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  max-height: 600px; /* adjust depending on expected calendar height */
  opacity: 1;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
